export default "__VITE_ASSET__DlSl_j$g__"